const DEFAULT_LOCALE =  'en_GB';

// If the current locale is not in the flows config's set of specified locales, redirect to the default locale
export default (flowConfigLocales) => {
  const parsedURL = new URL(window.location.href);
  const { origin, search } = parsedURL;
  const [, locale, environment, learnLanguageAlpha3, flow, node, nodeIndex] = parsedURL.pathname.split('/');
  if (!learnLanguageAlpha3 || !flow) return;
  if (!flowConfigLocales.includes(locale)) {
    window.location.replace(
      `${origin}/${DEFAULT_LOCALE}/${environment}/${learnLanguageAlpha3}/${flow}/${node}/${nodeIndex}${search}`
    );
  }
};
